export default __webpack_public_path__ + "static/rsz_dn-8da3af42f68d108d1aac329d329b5d9a.png";